export { default } from "./UserManagementEdit";
